<template>
  <v-container id="productos_restaurante" tag="section">
    <base-v-component heading="Catálogos del Restaurante " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          :loading="loadingGuardar"
          color="primary"
          :disabled="catalogosCambiados.length == 0"
          @click="guardarCambios"
          >Guardar</v-btn
        >
        <!-- <v-btn
					color="secondary"
					@click="resetearCatalogo"
					:loading="loadingReset"
				>
					Resetear</v-btn
				>
				<v-btn
					disabled
					color="primary"
					@click="generarCatalogo"
					:loading="loadingGenerarCatalogo"
				>
					Generar Público</v-btn
				>
				<v-btn
					color="primary"
					@click="migrarACatalogo"
					:loading="loadingGenerarCatalogo"
				>
					Migrar a catalogo</v-btn
				> -->
      </v-toolbar>

      <v-toolbar>
        <v-row align="center">
          <v-radio-group v-model="switchViendo" row>
            <v-radio label="Productos" value="productos"></v-radio>
            <v-radio label="Modificadores" value="modificadores"></v-radio>
          </v-radio-group>
          <v-select
            v-if="switchViendo == 'productos'"
            class="mt-4"
            :items="categorias"
            v-model="categoria"
            label="Categoria"
          ></v-select>
          <v-select
            v-if="switchViendo == 'modificadores'"
            class="mt-4 mx-4"
            :items="modificadores"
            v-model="modificador"
            label="Modificador"
          ></v-select>
          <!-- <v-select
          class="mt-4"
          :items="cambiarCatalogosJuntosItems"
          v-model="cambiarCatalogosJuntos"
          label="Cambiar Catalogos Juntos"
          multiple
        ></v-select> -->
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <!-- <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn> -->
        </v-row>
      </v-toolbar>

      <v-data-table
        :search="search"
        :items="productosFilter"
        :headers="headers"
        :loading="loading"
        :key="productos.id"
        dense
      >
        <template v-slot:item="{ item }">
          <tr :key="item.id">
            <td>{{ item.nombreMostrar }}</td>
            <template v-for="(cat, i) in item.catalogos">
              <td :key="`global_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-checkbox
                  v-model="cat.global"
                  dense
                  @change="cambiarAsociado(cat)"
                />
              </td>
              <td
                v-if="!cat.global"
                :key="`activo_${i}`"
                :class="colores[i % 6] + ' lighten-4'"
              >
                <v-checkbox
                  v-model="cat.activo"
                  dense
                  @change="cambiarAsociado(cat)"
                />
              </td>
              <td
                v-else
                :key="`activo_${i}`"
                :class="colores[i % 6] + ' lighten-4'"
              >
                <v-checkbox
                  disabled
                  v-model="cat.activoGlobal"
                  dense
                  @change="cambiarAsociado(cat)"
                />
              </td>
              <!-- <td :key="`impuesto_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-select
                  v-model="cat.impuesto"
                  :items="impuestos"
                  dense
                  hide-details
                  @change="cambiarAsociado(cat)"
                />
              </td> -->
              <td
                v-if="!cat.global"
                :key="`precio_${i}`"
                :class="colores[i % 6] + ' lighten-4'"
              >
                <v-text-field
                  dense
                  type="number"
                  step="0.5"
                  v-model="cat.precio"
                  @change="cambiarAsociado(cat)"
                />
              </td>
              <td
                v-else
                :key="`precio_${i}`"
                :class="colores[i % 6] + ' lighten-4'"
              >
                <v-text-field
                  dense
                  disabled
                  type="number"
                  step="0.5"
                  v-model="cat.precioGlobal"
                  @change="cambiarAsociado(cat)"
                />
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
      <!-- <v-data-table
        v-else
        :search="search"
        :items="opciones"
        disable-pagination
        hide-default-footer
        :headers="headers"
        :loading="loading"
        dense
      >
        <template v-slot:item="{ item }">
          <tr :key="item.id" :class="item.panel ? 'grey' : ''">
            <td>{{ item.nombre }}</td>
            <template v-for="(cat, i) in item.catalogo">
              <td :key="`activo_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-checkbox
                  v-model="cat.activo"
                  dense
                  @change="cambiarAsociado(cat)"
                />
              </td>

              <td :key="`precio_${i}`" :class="colores[i % 6] + ' lighten-4'">
                <v-text-field
                  dense
                  type="number"
                  step="0.5"
                  v-model="cat.precio"
                  @change="cambiarAsociado(cat)"
                />
              </td>
            </template>
          </tr>
        </template>
      </v-data-table> -->
    </base-material-card>
  </v-container>
</template>


<script>
import { mostrarIdioma } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      switchViendo: "productos", //productos o modificadores
      colores: ["yellow", "red", "blue", "purple", "green", "pink"],
      sinCambios: true,

      catalogosCambiados: [],
      loadingGuardar: false,
      loading: false,
      search: "",
      productos: [],
      opciones: [],
      loadingReset: false,
      loadingGenerarCatalogo: false,
      modificador: null, //para cambiar el modificador sobre el eque filtrar
      headersBruto: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombreMostrar",
        },
      ],
      cambiarCatalogosJuntos: null,
    };
  },
  watch: {
    // productosCatalogos(v) {
    //   this.computarProductos();
    // },
  },
  // asyncComputed: {
  //   default: [],
  // },
  computed: {
    modificadores() {
      return this.$store.state.productos.modificadores.map((p) => {
        return {
          text: p.descripcionInterna,
          value: p,
        };
      });
    },
    productosFilterBruto() {
      // console.log(this.tarifas);
      // console.log(this.productosCatalogos);
      // console.log(this.catalogos);
      var productosCatalogos = this.productosCatalogos;
      let res = this.productosBruto
        .filter((p) => p.individualPedible)
        .map((p) => {
          var catalogos = this.catalogos.map((catalogo) => {
            var precio = 0;
            var precioGlobal = 0;
            var activo = false;
            var activoGlobal = false;
            var global = true;
            var foundCatalogo = this.productosCatalogos.find(
              (pC) => pC.catalogo == catalogo.value
            );
            // console.log(foundCatalogo);
            let tarifaCatalogo =
              foundCatalogo && foundCatalogo.tarifa
                ? foundCatalogo.tarifa
                : null;

            if (tarifaCatalogo && p.tarifas) {
              let tarifa = foundCatalogo.tarifa ? foundCatalogo.tarifa : null;
              var foundTarifasCatalog = p.tarifas.find(
                (tar) => tar.id == tarifa
              );
              if (foundTarifasCatalog) {
                // console.log(foundTarifasCatalog);
                precioGlobal = foundTarifasCatalog.precio;
                activoGlobal = foundTarifasCatalog.activo;
              }
            }
            if (foundCatalogo && foundCatalogo.productos) {
              var foundProducto = foundCatalogo.productos.find(
                (pCat) => pCat.id == p.id
              );
              if (foundProducto) {
                precio = foundProducto.precio ? foundProducto.precio : 0;
                activo =
                  foundProducto.activo !== "undefined"
                    ? foundProducto.activo
                    : false;
                global =
                  foundProducto.global !== "undefined"
                    ? foundProducto.global
                    : true;
              } else {
                precio = 0;
                activo = false;
                global = true;
              }
            } else {
              precio = 0;
              activo = false;
              global = true;
            }
            return {
              catalogo: catalogo.value,
              precio: precio,
              activo: !!activo,
              precioGlobal: precioGlobal,
              activoGlobal: !!activoGlobal,
              global: !!global,
            };
          });

          return {
            catalogos: catalogos,
            ...p,
            nombreMostrar: Array.isArray(p.nombre)
              ? mostrarIdioma(p.nombre)
              : p.nombre,
          };
        });

      //calculamos los modificadores
      // console.log(this.$store.state.productos.modificadores);
      let modificadores = this.$store.state.productos.modificadores.map(
        (mod) => {
          return mod.opciones.map((op) => {
            var precio = 0;
            var precioGlobal = 0;
            var activo = false;
            var activoGlobal = false;
            var global = true;
            var catalogos = this.catalogos.map((catalogo) => {
              var foundCatalogo = this.productosCatalogos.find(
                (pC) => pC.catalogo == catalogo.value
              );
              //ponemos los precios de la tarifa global
              let tarifaCatalogo =
                foundCatalogo && foundCatalogo.tarifa
                  ? foundCatalogo.tarifa
                  : null;

              if (tarifaCatalogo && op.tarifas) {
                // console.log(op);
                var foundTarifasCatalog = op.tarifas.find(
                  (tar) => tar.id == tarifaCatalogo
                );
                if (foundTarifasCatalog) {
                  precioGlobal = foundTarifasCatalog.precio;
                  activoGlobal = foundTarifasCatalog.activo;
                }
              }

              //Ponemos los precios de la modificación por catálogos, si lo tiene
              if (foundCatalogo && foundCatalogo.productos) {
                let foundProducto = foundCatalogo.productos.find(
                  (pCat) => pCat.id == mod.id
                );
                if (!!foundProducto) {
                  precio = foundProducto.precio ? foundProducto.precio : 0;
                  activo =
                    foundProducto.activo !== "undefined"
                      ? foundProducto.activo
                      : false;
                  global =
                    foundProducto.global !== "undefined"
                      ? foundProducto.global
                      : true;
                } else {
                  precio = 0;
                  activo = false;
                  global = true;
                }
              } else {
                precio = 0;
                activo = false;
                global = true;
              }
              return {
                catalogo: catalogo.value,
                precio: precio,
                activo: !!activo,
                precioGlobal: precioGlobal,
                activoGlobal: !!activoGlobal,
                global: !!global,
              };
            });
            let nombreF = this.productosBruto.find((p) => p.id == op.id);
            return {
              idModificador: mod.id,
              id: op.id,
              nombreMostrar: !!nombreF ? mostrarIdioma(nombreF.nombre) : "",
              catalogos: catalogos,
            };
          });
          return {
            id: mod.id,
            modificador: true,
            opciones: mod.opciones.map((op) => {
              var catalogos = this.catalogos.map((catalogo) => {});
            }),
          };
        }
      );
      // console.log(modificadores.flat());
      // console.log(res);
      return [...res, ...modificadores.flat()];
      return this.productos.filter(
        (p) => p.categoria == this.categoria || !this.categoria
      );
    },
    categorias() {
      // this.categoriasSelect.splice(1, 0, {
      //   text: "Modificadores",
      //   value: "modificadores",
      // });
      return this.categoriasSelect;
    },
    cambiarCatalogosJuntosItems() {
      return this.catalogos;
    },
    productosFilter() {
      return this.productosFilterBruto.filter((p) => {
        return (
          (this.switchViendo == "productos" &&
            p.individualPedible &&
            (p.categoria == this.categoria || this.categoria === null)) ||
          (this.switchViendo == "modificadores" &&
            this.modificador &&
            p.idModificador == this.modificador.id)
        );
      });
    },

    ...mapGetters({
      negocio: "app/negocioGestObj",
      restGest: "app/restGestObj",
      categoriasSelect: "categorias/getCategoriasSelect",
      impuestos: "impuestos/getImpuestosSelect",
    }),
    ...mapState({
      productosBruto: (state) => state.productos.productosArray,
      catalogos: (state) => state.catalogos.catalogos,
      tarifas: (state) => state.productos.tarifas,
      productosCatalogos: (state) => state.catalogos.productosCatalogos,
    }),

    headers() {
      return [
        ...this.headersBruto,
        ...this.catalogos
          .map((h) => {
            return [
              {
                sortable: false,
                text: h.text + " Global",
                value: "global",
              },
              {
                sortable: false,
                text: h.text + " Activo",
                value: "activo",
              },
              // {
              //   sortable: false,
              //   text: h.text + " Impuesto",
              //   value: "impuesto",
              // },
              {
                sortable: false,
                text: h.text + " Precio",
                value: "precio",
              },
            ];
          })
          .flat(),
      ];
    },
    categoria: {
      get() {
        return this.$store.state.catalogos.categoriaFiltrar;
      },
      set(v) {
        this.$store.commit("catalogos/setCategoriaFiltrar", v);
      },
    },
  },
  methods: {
    ...mapActions({
      getTodosCatalogos: "catalogos/getTodosCatalogos",
    }),
    reload() {
      this.getTodosCatalogos().finally(() => (this.loading = false));
    },
    verOpciones(item) {
      this.productoViendo = item;
      this.computarOpciones();
    },
    volver() {
      var resultado = [];
      this.opciones
        .filter((o) => !o.panel)
        .map((op) => {
          //recorremos los catálogos de la opción
          op.catalogo.map((opCat) => {
            var foundIndex = resultado.findIndex(
              (r) => r.catalogo == opCat.catalogo
            );
            let insertar = {
              id: op.id,
              activo: opCat.activo ? opCat.activo : false,
              precio: parseFloat(opCat.precio),
            };
            if (foundIndex > -1) {
              resultado[foundIndex].opciones.push(insertar);
            } else {
              resultado.push({
                catalogo: opCat.catalogo,
                opciones: [insertar],
              });
            }
          });
        });

      // this.productoViendo.opciones = this.opciones;
      resultado.map((res) => {
        var foundIndex = this.productoViendo.catalogo.findIndex(
          (c) => c.catalogo == res.catalogo
        );

        if (foundIndex > -1) {
          this.productoViendo.catalogo[foundIndex].opciones = res.opciones;
        }
      });

      this.productoViendo = null;
    },
    computarProductos() {
      this.loading = true;
      this.productos = this.productosBruto.map((p) => {
        var pCatalogo = this.productosCatalogos.map((cat) => {
          var found = cat.productos.find((pCat) => pCat.id == p.id);
          return {
            catalogo: cat.catalogo,
            precio: found ? found.precio : 0,
            activo: found ? found.activo : false,
            impuesto: found ? found.impuesto : this.restGest.impuesto,
            opciones: found ? found.opciones : [],
          };
        });

        return {
          id: p.id,
          nombre: mostrarIdioma(p.nombre),
          categoria: p.categoria,
          catalogo: pCatalogo,
          opciones: p.opciones,
        };
      });
      this.loading = false;
    },
    computarOpciones() {
      var res =
        this.productoViendo && this.productoViendo.opciones
          ? this.productoViendo.opciones
              .filter((op) => !!op.opciones)
              .map((op) => {
                return [
                  {
                    nombre: Array.isArray(op.panel)
                      ? mostrarIdioma(op.panel)
                      : op.panel,
                    panel: true,
                  },
                  ...op.opciones.map((ops) => {
                    var opsCatalogo = this.productoViendo.catalogo.map(
                      (cat) => {
                        var found = cat.opciones.find(
                          (opCat) => opCat.id == ops.id
                        );
                        return {
                          catalogo: cat.catalogo,
                          precio: found ? found.precio : 0,
                          activo: found ? found.activo : false,
                        };
                      }
                    );
                    return {
                      nombre: mostrarIdioma(ops.title),
                      id: ops.id,
                      catalogo: opsCatalogo,
                    };
                  }),
                ];
              })
          : [];
      this.opciones = res.flat();
    },
    resetearCatalogo() {
      this.loadingReset = true;
      this.$store
        .dispatch("catalogos/resetearCatalogo")
        .then(() => {
          this.computarProductos();
        })
        .catch((e) => console.log)
        .finally(() => (this.loadingReset = false));
    },
    migrarACatalogo() {
      this.loadingGenerarCatalogo = true;
      return this.$store
        .dispatch("catalogos/migrarACatalogoTodos")
        .then(() => {
          this.computarProductos();
        })
        .catch((e) => console.log)
        .finally(() => (this.loadingGenerarCatalogo = false));
    },
    generarCatalogo() {
      this.loadingGenerarCatalogo = true;
      return this.$store
        .dispatch("catalogos/generarCatalogosPublicos", this.catalogosCambiados)
        .then(() => {})
        .catch((e) => console.log)
        .finally(() => (this.loadingGenerarCatalogo = false));
    },
    cambiarAsociado(item) {
      if (this.catalogosCambiados.indexOf(item.catalogo) == -1)
        this.catalogosCambiados.push(item.catalogo);
      this.sinCambios = false;
    },
    guardarCambios() {
      var resultado = this.catalogos.map((c) => {
        return {
          catalogo: c.value,
          productos: [],
        };
      });
      this.productosFilterBruto.map((p) => {
        p.catalogos.map((pCat) => {
          if (!pCat.global) {
            //se guarda sólo si no es global
            let insertar = {
              id: p.id,
              global: pCat.global,
              precio: pCat.precio,
              activo: pCat.activo,
            };
            var foundIndex = resultado.findIndex(
              (r) => r.catalogo == pCat.catalogo
            );
            if (foundIndex > -1) {
              resultado[foundIndex].productos.push(insertar);
            } else {
              resultado.push({
                catalogo: pCat.catalogo,
                productos: [insertar],
              });
            }
          }
        });
      });
      this.loading = true;
      this.loadingGuardar = true;
      const _vm = this;
      this.$store
        .dispatch("catalogos/setCatalogo", resultado)
        .then(() => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Catálogo actualizado: " + this.catalogosCambiados,
          });
          // return this.generarCatalogo();
        })
        .then(() => {
          // this.$store.dispatch(
          //   "catalogos/generarCatalogosPublicosFunctionsCheck"
          // );
        })
        // .then(() => {
        //   this.$store.commit("snackbar/setMensajeSuccess", {
        //     msj: "Catálogo generado: " + this.catalogosCambiados,
        //   });
        // })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al actualizar eel catálogo: " + error,
          });
        })
        .finally(() => {
          _vm.loadingGuardar = false;
          _vm.loading = false;
          _vm.catalogosCambiados = [];
        });
    },
  },
  mounted() {
    this.loading = true;
    return Promise.all([
      this.$store.dispatch("productos/getModificadores"),
      this.$store.dispatch("productos/getGruposModificadores"),
      this.getTodosCatalogos(),
    ]).finally(() => (this.loading = false));
    // .then(() => {
    //   this.computarProductos();
    // })
  },
};
</script>

<style>
</style>